import React, { useContext } from "react"
import tw from "twin.macro"

import { Header, Footer } from "."

const LocationContext = React.createContext<Location | undefined>(undefined)

interface Props {
  location: Location
  title: string
}

export const Layout: React.FC<Props> = ({ location, children }) => {
  return (
    <StyledLayout.Wrapper>
      <LocationContext.Provider value={location}>
        <Header location={location} />
        <StyledLayout.Main>{children}</StyledLayout.Main>
        <Footer />
      </LocationContext.Provider>
    </StyledLayout.Wrapper>
  )
}

export const useLocation = () => {
  const context = useContext(LocationContext)
  if (!context) {
    throw new Error(`Layout must receive location prop`)
  }
  return context
}

const StyledLayout = {
  Wrapper: tw.div`flex flex-col min-h-screen bg-background-gray`,
  Main: tw.main`flex flex-col flex-1 pb-8`,
}
